<div class="redirect-wrap d-flex flex-column align-items-center">
  <app-text class="m-4 text-c300 body-m">{{locale?.redirecting}}...</app-text>
  <div class="redirect-loader"></div>
</div>
